// extracted by mini-css-extract-plugin
export default {"outer":"email_outer__3OHte","width":"email_width__w7oTl","imgWidth":"email_imgWidth__19N5s","p":"email_p__zVWWB"};